import { useState } from "react";

// Company filter, remembered per page; the active page's choice is sent as the X-Company header
const PATHS = ["/", "/routes", "/shipments", "/fleet", "/analytics", "/reports", "/comparison", "/trucks-on-road", "/driver-scorecard",
  "/dispatcher-leaderboard", "/dispatcher-rankings", "/dispatcher-comparison", "/load-heatmap", "/fleet-map", "/fuel-report", "/relay-fuel"];
const OPTIONS = [["", "All"], ["AFT", "AFT"], ["PGL", "PGL"], ["EAH", "EAH"]];
const NAMES = { AFT: "All Freight Trans", PGL: "Premium Group Logistics", EAH: "Express Auto Haulers" };
let active = "";

export const activeCompany = () => active;
const pageKey = (path) => (path.startsWith("/dispatcher/") ? "/dispatcher" : path);
export const companyPage = (path) => PATHS.includes(path) || path.startsWith("/dispatcher/");
export const savedCompany = (path) => (companyPage(path) ? localStorage.getItem(`company:${pageKey(path)}`) || "" : "");
// Called during layout render so the page's first requests already carry the right company
export const syncActiveCompany = (path) => { active = savedCompany(path); return active; };

export const CompanyFilter = ({ path, onChange }) => {
  const [val, setVal] = useState(savedCompany(path));
  const pick = (v) => {
    localStorage.setItem(`company:${pageKey(path)}`, v);
    active = v;
    setVal(v);
    onChange(v);
  };
  return (
    <div data-testid="company-filter" className="flex items-center justify-end gap-2">
      {val && <span data-testid="company-filter-label" className="text-[11px] text-slate-500">Showing {NAMES[val]} only</span>}
      <div className="inline-flex rounded-xl border border-slate-800 bg-slate-900/70 p-1">
        {OPTIONS.map(([v, l]) => (
          <button key={l} type="button" data-testid={`company-filter-${l.toLowerCase()}`} aria-pressed={val === v} onClick={() => pick(v)}
            className={`rounded-lg px-3.5 py-1 text-xs font-semibold transition-colors ${val === v ? "bg-blue-600 text-white shadow" : "text-slate-400 hover:text-slate-200"}`}>{l}</button>
        ))}
      </div>
    </div>
  );
};
